import type { Employee, JobStatus, JobCompletionChecklist } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import type { JobWithRelations } from './jobs.api';
import { api } from './client';

/** Vista del técnico (capa de operaciones, PASO 3). Prefijo: /api/me */

/** Acción de ponche: Llegué / Terminé / No terminé. */
export type PunchAction = 'arrived' | 'completed' | 'not_completed';

/** Empleado detrás del usuario autenticado (o lanza 403 si no tiene ficha). */
export const getMyEmployee = () => api.get<Employee>('/api/me/employee');

/** Sube la foto de perfil PROPIA del técnico (multipart, imagen). */
export const uploadMyPhoto = (file: File) => {
  const form = new FormData();
  form.append('file', file);
  return api.post<Employee>('/api/me/photo', form);
};

/**
 * Reporte pasivo de ubicación (última posición conocida para el Tracking).
 * Se manda al entrar a /mis-trabajos y cada pocos minutos con la vista abierta.
 */
export const reportLocation = (lat: number, lng: number) =>
  api.post<Employee>('/api/me/location', { lat, lng });

/** SOLO los trabajos asignados a este técnico (scoping en el backend). */
export const listMyJobs = (params: { estado?: JobStatus } = {}) =>
  api.get<Paginated<JobWithRelations>>('/api/me/jobs', { query: params });

/**
 * "Cliente no llegó" (Fase 2): reporta el no-show al dueño. No cambia el
 * estado — cancelar es decisión del panel. Idempotente por trabajo.
 */
export const reportNoShow = (jobId: string) =>
  api.post<{ reported: boolean; alreadyReported: boolean }>(`/api/me/jobs/${jobId}/no-show`);

export const punch = (
  jobId: string,
  input: {
    action: PunchAction;
    resultado?: string | null;
    motivo?: string | null;
    checklist?: JobCompletionChecklist;
    registroProducto?: string | null;
    /** Cierre con validación: modelo instalado y número de serie ("Terminé"). */
    modelo?: string | null;
    numeroSerie?: string | null;
    /** Tipificación que propone el técnico al cerrar una garantía. */
    nivelResolucionPropuesto?: string | null;
    causaRaizPropuesta?: string | null;
    lat?: number | null;
    lng?: number | null;
  },
) => api.post<JobWithRelations>(`/api/me/jobs/${jobId}/punch`, input);
